<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="home" href="/tabs/home">
          <icon-building-cottage aria-hidden="true" />
          <ion-label>{{ t('tabs.home') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="marketplace" href="/tabs/marketplace">
          <icon-building-store aria-hidden="true" />
          <ion-label>{{ t('tabs.marketplace') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="garden" href="/tabs/garden">
          <icon-plant aria-hidden="true" />
          <ion-label>{{ t('tabs.garden') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="inbox" href="/tabs/inbox">
          <icon-mailbox aria-hidden="true" />
          <ion-label>{{ t('tabs.inbox') }}</ion-label>
          <ion-badge v-if="unreadBadgeCount > 0" class="inbox-unread-dot" color="danger" aria-hidden="true" />
        </ion-tab-button>

        <ion-tab-button tab="settings" href="/tabs/settings">
          <icon-settings aria-hidden="true" />
          <ion-label>{{ t('tabs.settings') }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue';
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonPage, IonRouterOutlet, IonBadge } from '@ionic/vue';
import { useInboxStore } from '@/stores/inbox';
import { IconBuildingCottage, IconBuildingStore, IconMailbox, IconPlant, IconSettings } from '@tabler/icons-vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const inbox = useInboxStore();
const unreadBadgeCount = computed(() => inbox.unreadSummary?.total_badge_count ?? 0);

onMounted(() => {
  void inbox.fetchUnreadSummary();
  inbox.startUnreadPolling(() => {
    void inbox.fetchUnreadSummary();
  }, 20000);
});

onUnmounted(() => {
  inbox.stopUnreadPolling();
});
</script>

<style scoped>
.inbox-unread-dot {
  min-width: 8px;
  width: 8px;
  height: 8px;
  padding: 0;
  border-radius: 999px;
}
</style>
